import { useState } from "react";
import PageWrapper from "../../common/components/PageWrapper";
import { useModal } from "../../../hooks/useModal";
import YouTubeVideoList from "../components/YouTubeVideoList";
import UpdateVideoModal from "../components/UpdateVideoModal";
import AddedVideoList from "../components/AddedVideoList";

export type Video = {
  videoContentId?: string;
  title: string;
  description: string;
  youtubeUrl: string;
  playTime: string;
  statusId: string;
  media: {
    file: File | null;
  };
  isInserted?: boolean;
  videoContentCategoryId: string;
};

export default function VideosContainer() {
  const [video, setVideo] = useState<null | Video>(null);
  const [isUpdateVideoModalOpen, { open, close }] = useModal();

  const openUpdateVideoModal = (video: Video) => {
    setVideo(video || null);
    open();
  };

  return (
    <>
      {isUpdateVideoModalOpen && video && (
        <UpdateVideoModal
          open={isUpdateVideoModalOpen}
          onClose={close}
          video={video}
        />
      )}
      <PageWrapper className="flex-row gap-1">
        <YouTubeVideoList onVideoSelect={openUpdateVideoModal} />
        <AddedVideoList onVideoSelect={openUpdateVideoModal} />
      </PageWrapper>
    </>
  );
}
